export default __webpack_public_path__ + "static/media/assemblyH1.c6468608.png";